/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import navbarAdminList from "@/layouts/components/navbar/navbarAdminList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "", // From Auth
  about       : "",
  // photoURL    : require("@/assets/images/portrait/small/avatar-s-11.png"), // From Auth
  status      : false,
  statusValue : 'Offline',
  userRole    : "admin",
  token       : null,
  listStudents: [
  ],
}
const domainWs = process.env.VUE_APP_DOMAIN_WS;
const api = process.env.VUE_APP_DOMAIN_WS_WINDOW_OPEN;
//  const domainWs = "http://181.39.135.147:7074/api/v1/"; // ws  de mapgrafi
// const domainWs = "http://181.39.135.147:8080/api/v1/"; // ws  de mapgrafi

var clasificacion_seleccionada = null
const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {}

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
  let userInfo = {}

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key] ?  userInfoLocalStorage[key] : userDefaults[key]
  })

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if(userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key]
  })

  return userInfo
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser             : getUserInfo(),
    domain                    : domainWs,
    api                       : api,
    clasificacion_seleccionada: clasificacion_seleccionada,
    bodyOverlay               : false,
    isVerticalNavMenuActive   : true,
    mainLayoutType            : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList    : navbarSearchAndPinList,
    navbarAdminList           : navbarAdminList,
    reduceButton              : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth      : "default",
    verticalNavMenuItemsMin   : false,
    scrollY                   : 0,
    starredPages              : navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    theme                     : themeConfig.theme || "light",
    themePrimaryColor         : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
}

export default state
